import PropTypes from 'prop-types';
// @mui
import { Grid, Stack, Typography } from '@mui/material';
import ShopProductCard from './ProductCard';

// ----------------------------------------------------------------------

ProductList.propTypes = {
  products: PropTypes.array.isRequired,
};
 
export default function ProductList({ products, ...other }) {
 
  
  return (
    <Grid container spacing={3} {...other}>
      {Object.keys(products).sort().map((product, index) => (
        <>
        <Typography variant='h5' sx={{m:2}}>{product}</Typography>
        <Grid container key={index} >
              {products[product].map((p, index)=>(
                <Grid item key={index} sx={{m:2}} xs={12} md={3}>
                <ShopProductCard product={p}  />
                </Grid>
              ))}
        </Grid>
        </>
      ))}
    </Grid>
  );
}
